var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"fwnz505lua","d":"M0 0L15 0 15 1.463 0 1.463z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(0 .857)","key":1},[React.createElement("mask",{"id":"ug0vbvpymb","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#fwnz505lua"})),React.createElement("path",{"fill":"#FFF","d":"M8.247 1.463h6.006c.413 0 .747-.327.747-.731C15 .328 14.666 0 14.253 0H.747C.334 0 0 .328 0 .732c0 .404.334.731.747.731h7.5z","mask":"url(#ug0vbvpymb)","key":1})])]);
}

Minus.defaultProps = {"width":"15","height":"3","viewBox":"0 0 15 3"};

module.exports = Minus;

Minus.default = Minus;
